export const SET_LOADING = 'SET_LOADING';
export const CLEAR_POKEMONS = 'CLEAR_POKEMONS';
export const SET_POKEMONS = 'SET_POKEMONS';
export const SET_TOTAL_OF_POKEMONS = 'SET_TOTAL_OF_POKEMONS';
export const SET_CURRENT_POKEMONS_PAGE = 'SET_CURRENT_POKEMONS_PAGE';
export const ADD_TO_POKEDEX = 'ADD_TO_POKEDEX';
export const REMOVE_FROM_POKEDEX = 'REMOVE_FROM_POKEDEX';
